/*
 * tp-my-printer.js
 * ------------------------------------------------------------
 * Merkt sich den Drucker eines Besuchers, damit die Startseite ihn beim
 * nächsten Besuch direkt anzeigt („Ihr Drucker: …“).
 *
 * Ablauf (alles nur im Browser des Besuchers, kein Server, keine Cookies):
 *   1. Ergebnisseite eines Druckers (/pages/druckersuche?hersteller=…&modell=…)
 *      → Drucker wird für diese Sitzung als Kandidat vermerkt (sessionStorage).
 *   2. Der Besucher legt etwas in den Warenkorb (/cart/add)
 *      → Kandidat wird dauerhaft gespeichert (localStorage, Schlüssel tp_my_printer).
 *   Die Bestellung selbst läuft im Shopify-Checkout, dort läuft kein Theme-Code;
 *   „in den Warenkorb gelegt“ ist deshalb der letzte erkennbare Schritt.
 *
 * API (window.tpMyPrinter):
 *   get()    – {b, s, m, img, url} oder null
 *   clear()  – gemerkten Drucker vergessen
 */
(function () {
  if (window.tpMyPrinter) return;

  var KEY = 'tp_my_printer';
  var CAND = 'tp_printer_candidate';
  var RESULTS_PATH = '/pages/druckersuche';

  function clean(s) {
    return String(s || '').replace(/[<>"'&\\\/]/g, '').trim().substring(0, 200);
  }
  function cleanImg(s) {
    s = String(s || '').trim().toLowerCase();
    return /^[a-z0-9][a-z0-9\-]*\.(jpg|jpeg|png|webp)$/.test(s) && s.length <= 120 ? s : '';
  }
  function read(store, key) {
    try {
      var v = JSON.parse(store.getItem(key));
      if (v && clean(v.b) && clean(v.m)) return { b: clean(v.b), s: clean(v.s), m: clean(v.m), img: cleanImg(v.img) };
    } catch (e) {}
    return null;
  }
  function write(store, key, p) {
    try { store.setItem(key, JSON.stringify(p)); } catch (e) {}
  }
  function url(p) {
    var q = new URLSearchParams();
    q.set('hersteller', p.b);
    if (p.s) q.set('serie', p.s);
    q.set('modell', p.m);
    if (p.img) q.set('img', p.img);
    return RESULTS_PATH + '?' + q.toString();
  }

  window.tpMyPrinter = {
    get: function () {
      var p = read(window.localStorage, KEY);
      if (p) p.url = url(p);
      return p;
    },
    clear: function () {
      try { window.localStorage.removeItem(KEY); window.sessionStorage.removeItem(CAND); } catch (e) {}
    }
  };

  /* 1) Ergebnisseite eines Druckers → Kandidat */
  try {
    if (window.location.pathname.replace(/\/$/, '') === RESULTS_PATH) {
      var q = new URLSearchParams(window.location.search);
      var cand = { b: clean(q.get('hersteller')), s: clean(q.get('serie')), m: clean(q.get('modell')), img: cleanImg(q.get('img')) };
      if (cand.b && cand.m) write(window.sessionStorage, CAND, cand);
    }
  } catch (e) {}

  /* 2) Warenkorb-Zugriff → Kandidat dauerhaft speichern */
  function commit() {
    var c = read(window.sessionStorage, CAND);
    if (c) write(window.localStorage, KEY, c);
  }
  if (window.fetch) {
    var orig = window.fetch;
    window.fetch = function (input) {
      try {
        var u = typeof input === 'string' ? input : input && input.url;
        if (u && /\/cart\/add(\.js)?(\?|$)/.test(u)) commit();
      } catch (e) {}
      return orig.apply(this, arguments);
    };
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && /\/cart\/add/.test(f.action)) commit();
  }, true);
})();
